module.exports = __webpack_public_path__ + "static/img/join.9f67a8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/BrandGmei/join.png
// module id = 1135
// module chunks = 18